import Vue from "vue";
import { deviceDetect } from "mobile-device-detect";
const state = () => ({
  // online
  online: true,
});

const mutations = {
  // online
  SET_ONLINE_STATE(state, value) {
    state.online = value;
  },
};

const actions = {
  // online
  setOnlineState({ commit }, value) {
    let self = this;
    commit("SET_ONLINE_STATE", value);
    if (value === true) {
      //User is Online

      this._vm.$firebase
        .firestore()
        .collection("users")
        .doc(this.state.Auth.user.uid.toString())
        .set(
          {
            dateLastConnexion: Date.now(),
            status: "online",
            //osName:deviceDetect().osName,
            //browserName:deviceDetect().browserName
          },
          { merge: true }
        )
        .then(() => {
          //
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
        });
    } else {
      //User is Offline
    }
  },
};

const getters = {
  online: (state) => {
    return state.online;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
